
export const Addresses = () => {
    return (
        <div>
            This is addresses page.
        </div>
    )
}
